export default __webpack_public_path__ + "static/media/Fidelity_and_Computer_Crime_Insurance_Policy_October_2022.8395b5c0.pdf";